import React from 'react';
import { Row, Col } from 'react-bootstrap';
interface AlertTemplateProps {
  alertType: string;
}
const AlertTemplate: React.FC<AlertTemplateProps> = ({ alertType }) => {
  return (
    <Row>
      <Col sm={2}>
        <div className='alertsApprovalAccordion_label'>Template:</div>
      </Col>
      <Col sm={10}>
        <div className='alertsApprovalAccordion_content'>
          <div className='alertsApproval_monitor-container'>
            <div className='alertsApproval_monitor'>
              <div className='alertsApproval_monitor_text'>
                <p>
                  {' '}
                  WARNING: Tornado inbound 3:00PM-6:00PM. Stay indoors unless
                  you want to die.
                </p>
              </div>
              <h2>{alertType}</h2>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default AlertTemplate;
